/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import hotkeys from 'hotkeys-js';
import toolbarList from '../toolbarActions/toolbarList';
import '@szhsin/react-menu/dist/index.css';
import './header.css';
import {
    ActionButton, Vsep, Hsep, Space, TextBox, Switcher, DropDown, FileUploader,
} from './HeaderComps';
import 'rc-switch/assets/index.css';

const setHotKeys = (actions) => {
    let keys = '';
    const map = {};
    actions.forEach((action, i) => {
        if (action.hotkey) {
            action.hotkey.split(',').forEach((key) => {
                [key, key.replace('Ctrl', 'Command')].forEach((k) => {
                    keys += `${k},`;
                    map[k] = document.getElementById(`action_${i + 1}`);
                });
            });
        }
    });
    hotkeys(keys, (event, handler) => {
        event.preventDefault();
        map[handler.shortcut].click();
    });
};

const Header = ({ superState, dispatcher }) => {
    const actions = toolbarList(superState);
    React.useEffect(() => {
        setHotKeys(actions, superState, dispatcher);
    }, []);

    return (
        <header className="header">
            <section className="middle titlebar">
                {
                    superState.graphs[superState.curGraphIndex] ? `${
                        superState.graphs[superState.curGraphIndex].projectDetails.projectName
                    } - DHGWorkflow Editor` : ''
                }
            </section>
            <section className="toolbar">
                {
                    actions.map(({
                        text, active, action, icon, type, hotkey,
                    }, i) => {
                        const props = {
                            text,
                            active,
                            tabIndex: i + 1,
                            key: text,
                            action: (e) => action(superState, dispatcher, e),
                            Icon: icon,
                            hotkey,
                        };
                        switch (type) {
                        case 'vsep': return <Vsep key={`${`v${i}`}`} />;
                        case 'space': return <Space key={`${`s${i}`}`} />;
                        case 'switch': return <Switcher {...props} />;
                        case 'menu': return <DropDown {...props} />;
                        case 'file-upload': return <FileUploader {...props} superState={superState} />;
                        case 'action': return <ActionButton {...props} />;
                        default: return <></>;
                        }
                    })
                }
            </section>
            <Hsep />
        </header>

    );
};

export {
    Header, ActionButton, Vsep, Hsep, Space, TextBox,
};
